import { observer } from 'mobx-react';
import ModalContent from './ModalContent';
import ModalPortal from './ModalPortal';
import { fromNullable } from 'maybeasy';

type ModalProps = React.ComponentProps<typeof ModalContent>;
interface ExtendedModalProps extends ModalProps {
  nodeId?: string;
  dimensions?: {
    maxHeight: string;
  };
  placement?: {
    zIndex: string;
  };
}

function Modal({ close, title, children, nodeId, dimensions, placement }: ExtendedModalProps) {
  return (
    <ModalPortal nodeId={fromNullable(nodeId).getOrElseValue('root')}>
      <ModalContent close={close} title={title} dimensions={dimensions} placement={placement}>
        {children}
      </ModalContent>
    </ModalPortal>
  );
}

export default observer(Modal);
